import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Electricmeter } from './electricmeter.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class ElectricmeterService {

    private resourceUrl = 'api/electricmeters';
    private resourceSearchUrl = 'api/_search/electricmeters';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(electricmeter: Electricmeter): Observable<Electricmeter> {
        const copy: Electricmeter = Object.assign({}, electricmeter);
        copy.updated = this.dateUtils.toDate(electricmeter.updated);
        copy.created = this.dateUtils.toDate(electricmeter.created);
        copy.lastValueChanged = this.dateUtils.toDate(electricmeter.lastValueChanged);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(electricmeter: Electricmeter): Observable<Electricmeter> {
        const copy: Electricmeter = Object.assign({}, electricmeter);

        copy.updated = this.dateUtils.toDate(electricmeter.updated);

        copy.created = this.dateUtils.toDate(electricmeter.created);

        copy.lastValueChanged = this.dateUtils.toDate(electricmeter.lastValueChanged);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Electricmeter> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            const jsonResponse = res.json();
            jsonResponse.updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            jsonResponse.lastValueChanged = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.lastValueChanged);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    private convertResponse(res: any): any {
        const jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
            jsonResponse[i].lastValueChanged = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].lastValueChanged);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        const options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            const params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter.service.ts